/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_LabelInputs */

const en_us2_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waist ÷ height`)
};

const pt_br2_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura ÷ altura`)
};

const es_419_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura ÷ estatura`)
};

const pt_pt2_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura ÷ altura`)
};

const fr_fr2_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille ÷ hauteur`)
};

const de_de2_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille ÷ Größe`)
};

const it_it2_body_assessment_whtr_label = /** @type {(inputs: Body_Assessment_Whtr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vita ÷ altezza`)
};

/**
* | output |
* | --- |
* | "Waist ÷ height" |
*
* @param {Body_Assessment_Whtr_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_label = /** @type {((inputs?: Body_Assessment_Whtr_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_label(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_label(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_label(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_label(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_label(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_label(inputs)
	return en_us2_body_assessment_whtr_label(inputs)
});
export { body_assessment_whtr_label as "body-assessment.whtr_label" }